// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"663e97f7","243":"d539504a","353":"b05de42f","453":"a7b53a70","487":"9cce184b","498":"588a8677","634":"3dce0ad0","655":"f13ecbfe","669":"f509bd3d","804":"b23c6fba","824":"b7fead37"}[chunkId] + ".chunk.js";
};